var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-container",attrs:{"id":"BlogBanner"}},[_c('el-carousel',_vm._l((_vm.imgArr.length),function(item){return _c('el-carousel-item',{key:item},[_c('h3',{staticClass:"small"},[_c('img',{staticClass:"imgArr",attrs:{"src":_vm.imgArr[item - 1],"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }